import gql from "graphql-tag";

export const getTips = (fragment: string) => gql`
  fragment TipFields on Education {
    ${fragment}
  }

  query Educations(
    $businessUnitInput: BusinessUnitInput!
    $orderBy: String
    $desc: Boolean
  ) {
    educations(
      businessUnitInput: $businessUnitInput
      orderBy: $orderBy
      desc: $desc
    ) {
      ...TipFields
    }
  }
`;
